//src/utils/Badges.js
import { FaMedal, FaCrown } from 'react-icons/fa';
export const BADGES = [
  { name: "Bronze",    threshold: 10,  color: "#cd7f32", icon: (props) => <FaMedal {...props} color="#cd7f32" /> },
  { name: "Silver",    threshold: 25,  color: "#c0c0c0", icon: (props) => <FaMedal {...props} color="#c0c0c0" /> },
  { name: "Gold",      threshold: 50,  color: "#ffd700", icon: (props) => <FaMedal {...props} color="#ffd700" /> },
  { name: "Platinum",  threshold: 100, color: "#4D4F51", icon: (props) => <FaMedal {...props} color="#4D4F51" /> },
  { name: "Diamond",   threshold: 200, color: "#00bfff", icon: (props) => <FaMedal {...props} color="#00bfff" /> },
  { name: "Legend",    threshold: Infinity, color: "#b084ff", icon: (props) => <FaCrown {...props} color="#b084ff" /> }
];

export function getBadge(total) {
  if (!total) return { badge: null, next: BADGES[0] };

  let badge = null, next = BADGES[0];
  for (const b of BADGES) {
    if (total >= b.threshold) badge = b;
    else {
      next = b;
      break;
    }
  }
  return { badge, next };
}